const mainSearchStyles = {
  control: styles => ({
    ...styles,
    cursor: 'pointer',
    '&:focus-within': {
      boxShadow: 'unset',
    },
    height: '100%',
    minWidth: '200px',
    maxWidth: '600px',
    width: '600px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  //   menu: () => ({
  //     width: '477px',
  //     borderRadius: '2px',
  //     marginLeft: '10px',
  //     margin: '10px 10px 0px 6px',
  //     fontFamily: 'Nunito',
  //     fontStyle: 'normal',
  //     fontWeight: '400',
  //     fontSize: '12px',
  //     lineHeight: '20px',
  //     backgroundColor: '#0D0D0D',
  //   }),
  valueContainer: () => ({
    width: '100%',
    height: '100%',
    marginLeft: '0px',
    gap: '10px',
    gridGap: '10px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: 'none',
    top: '0',
    bottom: '0',
    flexWrap: 'wrap',
  }),
  dropdownIndicator: styles => ({ ...styles, display: 'none' }),
  indicatorSeparator: styles => ({ ...styles, display: 'none' }),
  clearIndicator: styles => ({ ...styles, display: 'none' }),
  option: styles => ({
    ...styles,
    color: '#333333',
    fontSize: '15px',
    lineHeight: '20px',
  }),
  multiValue: () => ({
    gap: '4px',
    gridGap: '4px',
    padding: '3px',
    background: '#f0f0f0',
    borderRadius: '5px',
    fontSize: '15px',
    lineHeight: '20px',
    minWidth: 'auto',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-around',
  }),
  multiValueRemove: () => ({
    borderRadius: '2px',
    boxSizing: 'border-box',
    padding: '4px',
    cursor: 'pointer',
    backgroundColor: 'none',
    display: 'flex',
    alignItems: 'center',
    order: '2',
    '&:hover': {
      backgroundColor: 'gray',
      color: 'white',
    },
  }),
  multiValueLabel: () => ({
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '15px',
    lineHeight: '20px',
    paddingLeft: '8px',
    color: '#000 !important',
    order: 2,
  }),
  singleValue: styles => ({
    ...styles,
    color: '#000 !important',
  }),
  groupHeading: styles => ({
    ...styles,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'unset',
    fontSize: '18px',
    lineHeight: '20px',
    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
    padding: '5px 12px',
    backgroundColor: '#c1cad1',
  }),
  placeholder: () => ({
    color: 'rgba(0, 0, 0, 0.3)',
    position: 'absolute',
    marginLeft: '2px',
    marginRight: '2px',
    top: '50%',
    transform: 'translateY(-50%)',
    boxSizing: 'border-box',
    fontFamily: 'Sabon LT Std italic, sans-serif',
    fontStyle: 'italic',
    fontSize: '1rem',
    fontWeight: '400',
  }),
  input: styles => ({
    ...styles,
    color: 'rgba(0, 0, 0, 0.85)',
    margin: 0,
    padding: 0,
    fontFamily: 'Sabon LT Std, sans-serif',
    fontStyle: 'normal',
    fontSize: '1.44rem',
    fontWeight: '400',
  }),
};
export default mainSearchStyles;
